import BoardTemplateAddStep from './BoardTemplateAddStep';

export default BoardTemplateAddStep;
